import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';

export interface SocialLink {
  label: string;
  url: string;
}

export interface Contacts {
  phone: string;
  email: string;
  telegramChannel: string;
  telegramSupport: string;
  website: string;
  socials: SocialLink[];
}

export interface Instructions {
  title: string;
  steps: string[];
  footer: string;
}

export interface ReferralSettings {
  enabled: boolean;
  rewardAmount: number;
  minDepositToCount: number;
}

/* ⭐ Agent referral settings */
export interface AgentReferralSettings {
  enabled: boolean;
  defaultRewardAmount: number;
  minDepositAmount: number;
  rewardWindowDays: number;
  /* ⭐ NEW — ISO string or null */
  startedAt: string | null;
}

export interface WalletSettings {
  creditEnabled: boolean;
  withdrawalEnabled: boolean;
  minWithdrawalAmount: number;
  signupBonusEnabled: boolean;
  signupBonusAmount: number;
  /* ⭐ NEW — balance transfer settings */
  transferEnabled: boolean;
  minTransferAmount: number;
}

export interface SpinSettings {
  enabled: boolean;
  coinAmount: number;
}

export interface PlatformSettings {
  _id: string;
  key: string;
  contacts: Contacts;
  instructions: Instructions;
  referral: ReferralSettings;
  agentReferral: AgentReferralSettings;
  wallet: WalletSettings;
  spin: SpinSettings;
  createdAt: string;
  updatedAt: string;
}

export interface UpdatePlatformSettingsInput {
  contacts?: Partial<Contacts>;
  instructions?: Partial<Instructions>;
  referral?: Partial<ReferralSettings>;
  agentReferral?: Partial<AgentReferralSettings>;
  wallet?: Partial<WalletSettings>;
  spin?: Partial<SpinSettings>;
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

class PlatformSettingsService {
  async get(): Promise<PlatformSettings> {
    const res = await apiClient.get<ApiEnvelope<PlatformSettings>>(
      API_ENDPOINTS.PLATFORM_SETTINGS.GET
    );
    return res.data.data;
  }

  async update(input: UpdatePlatformSettingsInput): Promise<PlatformSettings> {
    const res = await apiClient.put<ApiEnvelope<PlatformSettings>>(
      API_ENDPOINTS.PLATFORM_SETTINGS.UPDATE,
      input
    );
    return res.data.data;
  }

  async reset(): Promise<PlatformSettings> {
    const res = await apiClient.post<ApiEnvelope<PlatformSettings>>(
      API_ENDPOINTS.PLATFORM_SETTINGS.RESET
    );
    return res.data.data;
  }
}

const platformSettingsService = new PlatformSettingsService();
export default platformSettingsService;